import { DOCUMENT, inject, Service } from '@angular/core';
import {
  hide as hideIntercom,
  show as showIntercom,
  showNewMessage as showIntercomNewMessage,
} from '@intercom/messenger-js-sdk';
import { ActionHelper } from '@onyx/angular';
import { LANDING_PAGE_URL } from '../../../common/constants/common/landing-pages';

@Service()
export class IntercomService {
  private readonly document = inject(DOCUMENT);
  private readonly actionHelper = inject(ActionHelper);

  public startConversation(initialMessage?: string): void {
    if (!this.isAvailable()) {
      if (initialMessage) this.actionHelper.copy(initialMessage);

      ActionHelper.openLink(LANDING_PAGE_URL.CONTACT);
      return;
    }

    showIntercomNewMessage(initialMessage ?? '');
  }

  public toggleMessenger(): void {
    if (!this.isAvailable()) {
      ActionHelper.openLink(LANDING_PAGE_URL.CONTACT);
      return;
    }

    this.isActive() ? hideIntercom() : showIntercom();
  }

  private isAvailable(): boolean {
    return !!this.document.querySelector('#intercom-frame');
  }

  private isActive(): boolean {
    return !!this.document.querySelector(
      '.intercom-app > [style*="opacity: 1"]',
    );
  }
}
